import { render, staticRenderFns } from "./lottery-record-header.vue?vue&type=template&id=447d7043&scoped=true&lang=pug&"
import script from "./lottery-record-header.vue?vue&type=script&lang=js&"
export * from "./lottery-record-header.vue?vue&type=script&lang=js&"
import style0 from "./lottery-record-header.vue?vue&type=style&index=0&id=447d7043&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d7043",
  null
  
)

export default component.exports